import { vendor } from "helpers/vendorHelper";
import { getAppConfig } from "services/configService";
import { DELETE, GET, POST, PUT } from "services/httpService";
import urlJoin from "url-join";

const apiUrl = () => {
  return getAppConfig().WidgetGalleryApi;
};

export const getGalleryEntryByWidgetId = async widgetId => {
  return await GET({ includeToken: true }, urlJoin(apiUrl(), `/v1/galleryentries/${widgetId}?channel=${vendor}`));
};

export const postGalleryEntry = async payload => {
  return await POST({ includeToken: true }, urlJoin(apiUrl(), `/v1/galleryentries/`), payload);
};

export const putGalleryEntry = async payload => {
  return await PUT(
    { includeToken: true },
    urlJoin(apiUrl(), `/v1/galleryentries/${payload.widgetId}?channel=${vendor}`),
    payload
  );
};

export const deleteGalleryEntry = async widgetId => {
  return await DELETE({ includeToken: true }, urlJoin(apiUrl(), `/v1/galleryentries/${widgetId}?channel=${vendor}`));
};

export const getCategoryNames = async () => {
  return await GET({ includeToken: true }, urlJoin(apiUrl(), `/v1/categories`));
};
